import { render, staticRenderFns } from "./commodityData.vue?vue&type=template&id=b504715e&"
import script from "./commodityData.vue?vue&type=script&lang=js&"
export * from "./commodityData.vue?vue&type=script&lang=js&"
import style0 from "./commodityData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports